import RegexUtils from 'utils/RegexUtils';
import { object, string, array, boolean } from 'yup';

const { phoneRegex } = RegexUtils;

const ServiceScheduleSchema = object().shape(
    {
        lotName: string().required().max(50),
        name: string().required().max(140),
        lastName: string().required().max(140),
        email: string().email().when('phone', {
            is: (phone: string) => !phone || phone.length === 0,
            then: string().email().required(),
            otherwise: string()
        }),
        phone: string().when('email', {
            is: (email: string) => !email || email.length === 0,
            then: string().required().matches(phoneRegex, 'cell phone is not valid, please use this format 999-999-9999'),
            otherwise: string()
        }),
        year: string().required(),
        make: string().required(),
        model: string().required(),
        mileage: string().required(),
        time: string().required(),
        // optional fields
        contactPreference: string().required(),
        underWarranty: string().required(),
        requestedServices: array().of(string()).min(1, 'Please select at least one service'),
        description: string(),
        preferredDate: string().required(),
        disclaimerAccepted: boolean()
            .oneOf([true], 'You must accept the disclaimer to continue')
            .required(),
    }, [['email', 'phone']]);

export default ServiceScheduleSchema;
